/* @flow */
import ArticleSearchClient from "../clients/ArticleSearchClient";
import { keyForIds } from "../utils/RestrictionUtils";
type Ids = Array<string>;

class RestrictionsStore {
    cachedRestrictions: Map<string, string> = new Map();
    constructor() {
        this.cachedRestrictions = new Map();
        window.setInterval(() => {
            this.resetCache();
        }, 1000 * 60 * 60); // Clear Cache every Hour
    }

    resetCache() {
        this.cachedRestrictions = new Map();
    }

    getRestrictionId(ids: Array<string>) {
        const key = keyForIds(ids);
        return this.cachedRestrictions.get(key);
    }

    setRestrictionId(restrictionId: string, ids: Ids) {
        const key = keyForIds(ids);
        this.cachedRestrictions.set(key, restrictionId);
    }

    getRestrictions(ids: Ids, doSearchCallback: (restrictionId: string) => void, errorCallback: (error: any) => void) {
        ArticleSearchClient.getRestrictions(ids)
            .then((response) => {
                this.setRestrictionId(response.key, ids);
                doSearchCallback(response.key);
            })
            .catch(errorCallback);
    }

    doSearchWithRestriction(
        articleIds: Ids,
        searchCallback: (restrictionId: string) => void,
        errorCallback: (error: any) => void
    ) {
        const restrictionId = this.getRestrictionId(articleIds);
        if (!restrictionId) {
            this.getRestrictions(articleIds, searchCallback, errorCallback);
        } else {
            searchCallback(restrictionId);
        }
    }
}

export default new RestrictionsStore();
